<div
  class="pill"
  [ngClass]="{ selected: selected, 'enable-switch': enableSwitch, clickable: toggle.observers.length }"
  [ngStyle]="styles"
  (click)="click()">
  <span class="pill-content">{{ attribute?.name }}</span>
</div>
